
import { createSlice } from '@reduxjs/toolkit';

export const reportSlice = createSlice({
    name:'reportSlice',
    initialState:{
        loading: false,
        data: {

        },
         type_data: {

        },
        sent: false,
        error: false,
    },
    reducers:{
        REPORT_FETCH_START:(state)=>{
            state.loading=true
        },
        REPORT_FETCH_SENT:(state)=>{
            state.sent=true
        },

         REPORT_TYPE_FETCH_SUCCESS:(state,action)=>{
            state.type_data=action.payload
        },
        REPORT_FETCH_SUCCESS:(state,action)=>{
            state.loading=false
            state.sent=false
             state.data=action.payload
        },
        REPORT_FETCH_ERROR:(state)=>{
            state.error=true
        }
    }
});

export const {REPORT_TYPE_FETCH_SUCCESS, REPORT_FETCH_START,REPORT_FETCH_ERROR,REPORT_FETCH_SUCCESS,REPORT_FETCH_SENT }=reportSlice.actions;
export default reportSlice.reducer;